/**
 * Tropicalización de UI: qué pestañas/rutas de operación vertical ve un tenant.
 *
 * Regla (skill tenant-tropicalizacion + S134.1 revertido en UI):
 * - vertical primaria (`dict.vertical`)
 * - o `dict.secondary_verticals` (lista explícita)
 * - `is_corp_account` NO desbloquea módulos de otro giro (Corp = techos de plan).
 */

export function normalizeVerticalKey(key) {
  return String(key || '').trim().toLowerCase();
}

/**
 * @param {object|null|undefined} dict — respuesta de GET /tenant/business/dictionary
 * @param {string|string[]} keys — vertical(es) permitidas
 */
export function tenantHasVertical(dict, keys) {
  const want = (Array.isArray(keys) ? keys : [keys])
    .map(normalizeVerticalKey)
    .filter(Boolean);
  if (!want.length) return false;
  const primary = normalizeVerticalKey(dict?.vertical);
  if (primary && want.includes(primary)) return true;
  const secondary = (dict?.secondary_verticals || [])
    .map(normalizeVerticalKey)
    .filter(Boolean);
  return want.some((k) => secondary.includes(k));
}
